import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '../assets/images/LOGO.png';

function ErrorScreen() {
  return (
    <Box sx={{ height: '100vh', backgroundColor: '#365DEC' }}>
      <Stack
        alignItems="center"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Box
          component="img"
          src={Logo}
          alt="Product"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'scale-down',
            objectPosition: 'center',
          }}
        />
        <Typography
          component="h1"
          variant="headline1"
          marginBlock="30px 10px"
          color="#fff"
        >
          שגיאה 404 - דף לא נמצא
        </Typography>
        <Link to="/home-page">
          <Button variant="containedRed">לדף הבית</Button>
        </Link>
      </Stack>
    </Box>
  );
}

export default ErrorScreen;
